        /* PROD SLIDER */
        // $('.product-gallery-left').slick({
        //     prevArrow: '<button class="product-gallery-left__btn product-gallery-left__btn-prev"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.9603 14.9604L2.4603 8.46045L8.9603 1.46045" stroke="#2D4694" stroke-width="3"/></button>',
        //     nextArrow: '<button class="product-gallery-left__btn product-gallery-left__btn-next"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M2 2L8.5 8.5L2 15.5" stroke="#2D4694" stroke-width="3"/></svg></button>',
        //     slidesToShow:3,
    
        //     vertical: true,
        //     verticalSwiping: true,
        //     asNavFor: '.product-gallery-big',
        //     // centerMode: true,
        //     focusOnSelect: true,
        //     infinite: false,
        //     /* ↓ */
        //     arrows:false,
        //     /* ↑ */
            
        // });
        $('.product-gallery-left').slick({
            arrows: true,
            prevArrow: '<button class="gallery__slider-btn gallery__slider-btn--next"><svg width="21" height="11" viewBox="0 0 23 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 11L11.5 3L21 11" stroke="#F19224" stroke-width="4"/></svg></svg></button>',
            nextArrow: '<button class="gallery__slider-btn gallery__slider-btn--prev"><svg width="21" height="11" viewBox="0 0 23 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 2L11.5 10L2 2" stroke="#F19224" stroke-width="4"/></svg></button>',
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 3,
            infinite: false,
            speed: 200 ,
            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    verticalSwiping: false,
                    vertical: false,
                    slidesToShow: 6,
                    arrows: true,
                    // infinite: true,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    verticalSwiping: false,
                    vertical: false,
                    slidesToShow: 5,
                    arrows: true,
                  }
                },
                {
                    breakpoint: 575,
                    settings: {
                      verticalSwiping: false,
                      vertical: false,
                      slidesToShow: 4,
                      arrows: true,
                    }
                },
                {
                    breakpoint: 435,
                    settings: {
                      verticalSwiping: false,
                      vertical: false,
                      slidesToShow: 3,
                      arrows: true,
                    }
                },
            ]
        });
        $('.product-gallery-card').slick({
            arrows: false,
            slidesToShow: 1,
            // variableWidth: true,
            // fade: true,
            infinite: false,
            speed: 200,
            // responsive: [
            //     {
            //       breakpoint: 575,
            //       settings: {
            //         arrows: true,
            //       }
            //     },
            // ]
        });
        const $left = document.querySelector('.product-gallery-left');
        if($left){
            const $galeryItem = document.querySelectorAll('.product-gallery-left__item');
            $left.addEventListener('click', (e)=> {
                if(e.target.classList.contains('product-gallery-left__img')){
                    const $item = e.target.closest('.product-gallery-left__item');

                    galleryHandler($item);

                    let dataImg = (e.target.dataset.img) - 1;
                    $('.product-gallery-card').slick('goTo', dataImg);
                }
            });
            $('.product-gallery-card').on('swipe', function(event, slick, currentSlide){
                const currentGalleryImage = $('.product-gallery-card').slick('slickCurrentSlide');
                let $item = document.querySelectorAll('.product-gallery-left__item')[currentGalleryImage];
                galleryHandler($item);
            });


            function galleryHandler(item) {
                $galeryItem.forEach(el=>{
                    el.classList.remove('product-gallery-left__item--active');
                })
                item.classList.add('product-gallery-left__item--active');
            }
        }


        // $('.product-gallery-big').slick('goTo', $dataImg);
        /* PROD SLIDER */
    
        /* КАРУСЕЛЬ */
        // $('.header__slider').slick({
        //     prevArrow: '<button class="header__slider-btn header__slider-btnprev"><img src="images/slider/slider-prev.svg" alt="prev"></button>',
        //     nextArrow: '<button class="header__slider-btn header__slider-btnnext"><img src="images/slider/slider-next.svg" alt="next"></button>',
        //     slidesToShow: 7,
        //     slidesToScroll: 1,
        //     infinite: false,
        //     // variableWidth: true,
        //     // variableWidth: true,
        //     responsive: [/* !!!!! */
        //         {
        //           breakpoint: 1600,
        //           settings: {
        //             slidesToShow: 6,
        //             slidesToScroll: 1,
        //           }
        //         }
        //     ]/* !!!! */
           
        // });
    
        $('.header__slider').slick({
            prevArrow: '<button class="header__slider-btn header__slider-btnprev"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.9603 14.9604L2.4603 8.46045L8.9603 1.46045" stroke="#2D4694" stroke-width="3"/></svg></button>',
            nextArrow: '<button class="header__slider-btn header__slider-btnnext"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M2 2L8.5 8.5L2 15.5" stroke="#2D4694" stroke-width="3"/></svg></button>',
            slidesToShow: 7,
            slidesToScroll: 1,
            infinite: false,
            // variableWidth: true,
            // variableWidth: true,
            responsive: [/* !!!!! */
                {
                  breakpoint: 1600,
                  settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                  }
                },
                {
                    breakpoint: 1201,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2,
                        arrows: false
                    }
                },
                {
                    breakpoint: 376,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2,
                        arrows: false
                    }
                },
            ]/* !!!! */
           
        });
    
    
        $('.banner-section__slider').slick({
            dots: true,
            prevArrow: '<button class="banner-section__slider-btn banner-section__slider-btnprev"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.9603 14.9604L2.4603 8.46045L8.9603 1.46045" stroke="#2D4694" stroke-width="3"/></button>',
            nextArrow: '<button class="banner-section__slider-btn banner-section__slider-btnnext"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M2 2L8.5 8.5L2 15.5" stroke="#2D4694" stroke-width="3"/></svg></button>',
            fade: true,
            responsive: [/* !!!!! */
                {
                  breakpoint: 991,
                  settings: {
                    arrows: false
                  }
                },
    
            ]/* !!!! */
    
           
        });
    
    
    
        $('.product-slider').slick({
            prevArrow: '<button class="product-slider__slider-btn product-slider__slider-btnprev"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.9603 14.9604L2.4603 8.46045L8.9603 1.46045" stroke="#2D4694" stroke-width="3"/></button>',
            nextArrow: '<button class="product-slider__slider-btn product-slider__slider-btnnext"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M2 2L8.5 8.5L2 15.5" stroke="#2D4694" stroke-width="3"/></svg></button>',
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 580,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: false
                    }
                },
                {
                    breakpoint: 426,
                      settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      arrows: false
                      }
                  }
            ]
        });
    
        $('.banner-section__slider--mini').slick({
            dots: true,
            arrows: false,
            fade: true,
            // prevArrow: '<button class="banner-section__slider-btn banner-section__slider-btnprev banner-section__slider--mini"><img src="images/slider/prev.svg" alt="prev"></button>',
            // nextArrow: '<button class="banner-section__slider-btn banner-section__slider-btnnext banner-section__slider--mini"><img src="images/slider/next.svg" alt="next"></button>',
           
        });
    
        /* КАРУСЕЛЬ */